"use strict";

exports.__esModule = true;
exports.wysiwygColors = exports.grayBorder = exports.brandGradientColorsMap = exports.brandGradientColors = void 0;
var brandGradientColorsMap = {
  "1.0": {
    aqua: "#008d95, #B3C98C",
    "aqua-2": "#0096A9, #9BD3DD",
    blue: "#003b66, #008d95",
    "blue-2": "#0033A0, #41B6E6",
    gray: "#e6e8e9, #ffffff",
    "light-gray": "#fafafa, #ffffff",
    orange: "#DC4405, #FDD355",
    "orange-2": "#EA7600, #FFB700",
    purple: "#003b66,  #8f297c",
    red: "#790000, #ed2224",
    "red-2": "#B1181E, #e2231a",
    violet: "#8f297d, #bc141a",
    "violet-2": "#662B7C, #CA3490"
  },
  "2.0": {
    aqua: "#0096A9, #9BD3DD",
    blue: "#0033A0, #41B6E6",
    "light-gray": "#f8f8f8, #ffffff",
    orange: "#EA7600, #FFB700",
    red: "#B1181E, #e2231a",
    violet: "#662B7C, #CA3490"
  }
};
exports.brandGradientColorsMap = brandGradientColorsMap;

var brandGradientColors = function brandGradientColors(color, version) {
  if (version === void 0) {
    version = "1.0";
  }

  return brandGradientColorsMap[version][color];
};

exports.brandGradientColors = brandGradientColors;
var grayBorder = "#e6e8e9";
exports.grayBorder = grayBorder;
var wysiwygColors = {
  blue: "#005daa",
  "dark-aqua": "#00acbd",
  "dark-blue": "#003b66",
  "dark-gray": "#222222",
  green: "#008d95",
  "light-aqua": "#89d1cc",
  "light-blue": "#70cfee",
  "light-orange": "#ffb500",
  orange: "#ffb500",
  purple: "#8f297c",
  red: "#ed2224"
};
exports.wysiwygColors = wysiwygColors;